import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import Lock from "../../types/Lock"
import DateTimeListItem from "../common/ListItems/DateTime";


export interface componentProps {
    item: Lock
}

const ItemGroupInfo: React.FC<componentProps> = ( {item} ) => {

    const {t} = useTranslation()

    return (
        <IonItemGroup>
            <IonItemDivider>
                {t('common.info')}
            </IonItemDivider>
            {item.locationCode &&
                <IonItem lines="full">
                    <IonLabel>{t('locks.form.location_code')}</IonLabel>
                    <IonNote className="ion-padding-vertical" slot="end">{item.locationCode || '-'}</IonNote>
                </IonItem>
            }
            <IonItem lines="full">
                <IonLabel>{t('locks.form.object')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.lockingObject || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('locks.form.programming_state')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.lockProgrammingState?.name || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full">
                <IonLabel>{t('locks.form.serial_number')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.serial || '-'}</IonNote>
            </IonItem>
            {item.externalId &&
            <IonItem lines="full">
                <IonLabel>{t('common.external_id')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{item.externalId || '-'}</IonNote>
            </IonItem>
            }
            <DateTimeListItem label={t('common.synced_at').toString()}
                              dateTime={item.meta?.syncedAt} />
        </IonItemGroup>
    )
}

export default ItemGroupInfo